import {useCallback, useMemo, useState} from 'react';

const SORT_DIRECTION_ASCENDING = 'asc';
const SORT_DIRECTION_DESCENDING = 'desc';

/**
 * @param {Object[]} rows
 * @param {string} initialSortFieldName
 * @returns {{sortedRows: Object[], sortByField: (fieldName: string) => void}}
 */
export default function useTableSort(rows, initialSortFieldName) {
    const [sortFieldName, setSortFieldName] = useState(initialSortFieldName);
    const [sortDirection, setSortDirection] = useState(SORT_DIRECTION_DESCENDING);

    const sortedRows = useMemo(() => {
        const directionMultiplier = sortDirection === SORT_DIRECTION_ASCENDING ? 1 : -1;

        return [...rows].sort((firstRow, secondRow) => {
            const firstValue = firstRow[sortFieldName];
            const secondValue = secondRow[sortFieldName];

            if (firstValue === null && secondValue === null) return 0;
            if (firstValue === null) return 1;
            if (secondValue === null) return -1;

            return (firstValue - secondValue) * directionMultiplier;
        });
    }, [rows, sortFieldName, sortDirection]);

    const sortByField = useCallback((clickedSortFieldName) => {
        setSortDirection((previousSortDirection) => (
            clickedSortFieldName === sortFieldName && previousSortDirection === SORT_DIRECTION_DESCENDING
                ? SORT_DIRECTION_ASCENDING
                : SORT_DIRECTION_DESCENDING
        ));
        setSortFieldName(clickedSortFieldName);
    }, [sortFieldName]);

    return {sortedRows, sortByField};
}
